import type { NextPage } from "next";
import { TermsOfIDPage } from "@/components/pages";
import { useRollbarContext } from "@rollbar/react";

const ID: NextPage = () => {
  useRollbarContext("terms/id");

  return <TermsOfIDPage />;
};

export default ID;
